import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import AppointmentOverview from './AppointmentOverview.js';

const AppointmentOverviewContainer = (_param)=>{
    var { appointment , store , isStoreLoading  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "appointment",
        "store",
        "isStoreLoading"
    ]);
    const { getLabel  } = useIntl();
    var _streetNumber, _additionalStreetInfo, _postalCode;
    const addressData = React.useMemo(()=>store ? {
            storeName: store.name,
            streetName: store.streetName,
            town: store.town,
            streetNumber: (_streetNumber = store.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : '',
            additionalStreetInfo: (_additionalStreetInfo = store.additionalStreetInfo) !== null && _additionalStreetInfo !== void 0 ? _additionalStreetInfo : '',
            postalCode: (_postalCode = store.postalCode) !== null && _postalCode !== void 0 ? _postalCode : ''
        } : undefined
    , [
        store
    ]);
    const labels = React.useMemo(()=>({
            child: getLabel('appointments.component.appointmentOverview.child'),
            additionalInformation: getLabel('appointments.component.appointmentOverview.additionalInformation')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentOverview, swcHelpers.extends({}, props, {
        appointment: appointment,
        labels: labels,
        addressData: addressData,
        isStoreLoading: isStoreLoading
    }));
};
var AppointmentOverviewContainer$1 = AppointmentOverviewContainer;

export { AppointmentOverviewContainer$1 as default };
//# sourceMappingURL=AppointmentOverviewContainer.js.map
